import { combineReducers } from "@reduxjs/toolkit";
import recruiterDetailsSlice from "./recruiterDetails/recruiterDetailsSlice";
import loginApi from "../apis/login";
import leftPanleActiveTabSlice from "./tabDetails/activeTabDetailsSlice";
import masterDataApi from "../apis/get-master-data";
import { jpmsApi } from "../apis/jpms";
import verifyServiceAPI from "../apis/verify-service";
import jobPostingFormSlice from "./jobPostingSlice/jobPostingSlice";
import questionnaireApi from "../apis/questionnaire";
import questionnaireFormSlice from "./questionnaireSlice/questionnaireSlice";
import errorFormSlice from "./errorSlice/errorSlice";
import questionnaireErrorSlice from "./errorSlice/questionnareErrorSlice/errorSlice";
import folderManagementApi from "../apis/folder-management";
import loginSlice from "./loginSlice";
import educationSlice from "./educationField/educationFieldSlice";
import masterDataSlice from "./masterDataFilterSlice/masterDataFilterSlice";

const rootReducer = combineReducers({
  // add reducers here ...
  [loginApi.reducerPath]: loginApi.reducer,
  [recruiterDetailsSlice.name]: recruiterDetailsSlice.reducer,
  [leftPanleActiveTabSlice.name]: leftPanleActiveTabSlice.reducer,
  [masterDataApi.reducerPath]: masterDataApi.reducer,
  [jpmsApi.reducerPath]: jpmsApi.reducer,
  [verifyServiceAPI.reducerPath]:verifyServiceAPI.reducer,
  [jobPostingFormSlice.name]:jobPostingFormSlice.reducer,
  [errorFormSlice.name]: errorFormSlice.reducer,
  [questionnaireApi.reducerPath]:questionnaireApi.reducer,
  [questionnaireFormSlice.name]:questionnaireFormSlice.reducer,
  [questionnaireErrorSlice.name]:questionnaireErrorSlice.reducer,
  [folderManagementApi.reducerPath]:folderManagementApi.reducer,
  [loginSlice.name]:loginSlice.reducer,
  [educationSlice.name]:educationSlice.reducer,
  [masterDataSlice.name]:masterDataSlice.reducer,
});

export default rootReducer;
